import { useEffect, useState } from 'react';
import { HomeseekerApplication } from '../../../api/homeseeker-application/findHomeSeekerApplicationById';
import BulkActionDropdownNew from '../bulk-action-dropdown/BulkActionDropdownNew';
import CandidatesHeader from '../candidates-header/CandidatesHeader';
import CandidatesRow from '../candidates-row/CandidatesRow';
import styles from './CandidatesTableNew.module.css';
import findListingById, { ContactRequestListingResponse } from '../../../api/transactional-listing/findListingById';
import Notifications from '../notifications/Notifications';
import { useTranslation } from 'react-i18next';

interface CandidatesTableProps {
    candidates: HomeseekerApplication[];
    transactionalListingId: string;
}

const CandidatesTableNew = ({
    candidates,
    transactionalListingId
}: CandidatesTableProps) => {
    const { t } = useTranslation();
    const [transactionalListing, setTransactionalListing] = useState<ContactRequestListingResponse>(null);

    const fetchListing = async () => {
        try {
            const response = await findListingById(transactionalListingId);
            setTransactionalListing(response);
        } catch (e) {
            Notifications.add({
                type: 'failed',
                message: t('api.request.failed')
            });
        }
    }

    useEffect(() => {
        if (transactionalListingId) {
            fetchListing();
        }
    }, []);

    return (
        <div className={styles.candidatesTable}>
            <BulkActionDropdownNew status='candidates' />
            <table>
                <CandidatesHeader />
                {
                    candidates &&
                    candidates.map((value, index) => {
                        return (
                            <CandidatesRow
                                key={index}
                                candidate={value}
                                transactionalListingId={transactionalListingId}
                                transactionalListing={transactionalListing}
                            />
                        );
                    })
                }
            </table>
        </div>
    );
}

export default CandidatesTableNew;
